
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gUrP306a_45uOEeUJfkWaIHQEfQFULqtJCd6EssyBUkIcEMeta } from "/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexUrLMOJknHqGSizD_sTwwutt6gSr4_45WxUhUaRiBtBOJQMeta } from "/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchfr86Cq_45StAIryGBHlA7_45blpoqHUZTmFP5iB1Cbgc_45TcMeta } from "/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index_45QpOB7UdY9iDihYl0T63j2Hk1YK3FUyAg51P4zQaiLsMeta } from "/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93lJ6qgP_QcbeXH2_45fSVhEwNk_A0I9ynbwKJ5CejdI5jYMeta } from "/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index7rfHclY2Dgd_7vF4EcAlR_gpD8K0CaHxKgU5AvFzf5AMeta } from "/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93GSXTDW_45o_459nXW6YdxFF_4iMSFW6eN_oLwutt1hXFF9cMeta } from "/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexzNYfFGZ3htWdTmyFeGr0M37KmnMdes9DOCH8YTH2xKIMeta } from "/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93VM9bIYmuu3QAZykKCyxBepmATQx_mU0p8u479djF7IEMeta } from "/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexuvrPbj0zcGF4dcKh0wU4ajX36HofSn_LkahmofCAV7IMeta } from "/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexDW1bHNG5wRIQKftxL0l4E_spHf0fKG2qGNdgTIdCgo8Meta } from "/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index7rfHclY2Dgd_7vF4EcAlR_gpD8K0CaHxKgU5AvFzf5AMeta || {},
    component: () => import("/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexzNYfFGZ3htWdTmyFeGr0M37KmnMdes9DOCH8YTH2xKIMeta || {},
    component: () => import("/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexuvrPbj0zcGF4dcKh0wU4ajX36HofSn_LkahmofCAV7IMeta || {},
    component: () => import("/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexDW1bHNG5wRIQKftxL0l4E_spHf0fKG2qGNdgTIdCgo8Meta || {},
    component: () => import("/codebuild/output/src3540445210/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]